import * as Request from '../Request';

const Menu = {
  // 新增菜单
  addMenu: (data) => {
    return Request.post('/sys/menu/save', data);
  },
  // 删除菜单
  delMenu: (data) => {
    return Request.delBody('/sys/menu/delete', data);
  },
  // 编辑菜单
  editMenu: (data) => {
    return Request.put('/sys/menu/update', data);
  },
  // 获取菜单列表
  getMenuList: (data) => {
    return Request.get('/sys/menu/tree', data);
  },
  // 获取菜单列表
  getMenuInfo: (data) => {
    return Request.get('/sys/menu/info', data);
  }
}
export default Menu
